<template>
  <div class="all">
    <div class="header_top">
      <div class="topTitle">
        <p class="title">人员信息</p>
      </div>
      <el-form inline style="padding: var(--middle-space) var(--big-space) 0;" @submit.native.prevent="getPersonList(1)">
        <el-form-item label="账号状态:" class="header_b">
          <el-select v-model="searchQuery.isEnabled" size="small" style="width: 120px" clearable filterable
            class="isEnabledsty" @change="getPersonList(1)">
            <el-option v-for="item in isqiyongoptions" :key="item.id" :value="item.id" :label="item.label" />
          </el-select>
        </el-form-item>
        <el-form-item label="人员类别:" class="header_b">
          <el-select v-model="searchQuery.isExternal" size="small" style="width: 120px" clearable filterable
            class="isEnabledsty" @change="getPersonList(1)">
            <el-option v-for="item in iswaioptions" :key="item.id" :value="item.id" :label="item.label" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="enableEditEnterpriseUser" class="header_b">
          <el-button v-if="addPersonInfo" plain size="small" type="primary" @click="yaoqing(2)"> 新增成员 </el-button>
          <el-button v-if="invitationInfo" plain type="primary" size="small" @click="yaoqing(1)">
            邀请成员
          </el-button>
          <el-button v-if="moreMember" plain size="small" type="primary" @click="gomorepersonInfo">
            更多成员
          </el-button>
          <el-button v-if="exportInfo" plain size="small" type="primary" @click="daoru(1)">
            批量邀请
          </el-button>
          <el-button v-if="exportBatch" plain size="small" type="primary" @click="daoru(2)">
            批量导入
          </el-button>
          <el-button v-if="deleBatchInfo" size="small" type="danger" plain :disabled="pageSelect.length == 0"
            @click="pldeletePerson">
            批量删除
          </el-button>
        </el-form-item>
        <div style="float: right; margin-top: 4px">
          <el-input v-model="searchQuery.keyword" placeholder="请输入姓名、账号、手机号" style="width: 307px" size="small"
            clearable @input="changeinput">
            <template #prefix>
              <i class="el-icon-search el-input__icon" @click="getPersonList(1)" />
            </template>
          </el-input>
        </div>
      </el-form>
      <editPerson ref="add" @getfreshen="getfreshen1" />
    </div>
    <div class="content">
      <el-table ref="multipleTable" v-loading="loading" :data="tableData" element-loading-text="拼命加载中" class="jk-table"
        highlight-current-row height="calc(100% - 80px)" border @row-click="handleDelete" @select-all="selectall"
        @select="selectchange">
        <template slot="empty">
          <img :src="zanwu" />
          <p style="font-size: 16px; color: #000; margin-top: 36px">
            暂无数据
          </p>
        </template>
        <el-table-column type="selection" align="center" />
        <el-table-column label="姓名" prop="name" align="center">
          <template #default="{ row }">
            <el-link v-if="seeInfo" type="primary" @click="detailInfo(row)">
              <span class="tabLinkSpan" :title="row.name">{{ row.name }}</span>
            </el-link>
            <span v-else class="tabLinkSpan" :title="row.name">{{ row.name }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column v-if="showUserName" label="用户名" prop="username" align="center" /> -->
        <el-table-column label="账号" prop="username" align="center" />
        <el-table-column label="手机号" prop="phone" min-width="120px" align="center" />
        <el-table-column label="性别" prop="$sex" min-width="120px" align="center" />
        <el-table-column label="部门" prop="depName" min-width="120px" align="center">
          <template slot-scope="scope">
            <span :title="scope.row.depNametitle">{{ scope.row.depName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="账号状态" prop="$isEnabled" min-width="120px" align="center" />
        <el-table-column label="人员类别" prop="isExternal" min-width="120px" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.isExternal == '1'">外部</span>
            <span v-if="scope.row.isExternal == '0'">内部</span>
          </template>
        </el-table-column>
        <el-table-column v-if="enableEditEnterpriseUser" label="操作" align="center" min-width="120px">
          <template slot-scope="scope">
            <span v-if="scope.row.isEnabled == 0 && enableInfo" class="btn" @click="qiyong(scope.row)">启用</span>
            <span v-if="scope.row.isEnabled == 1 && enableInfo" class="btn" @click="jinyong(scope.row)">禁用</span>
            <span v-if="editInfo" class="btn" @click="editPerson(scope.row)">修改</span>
            <span v-if="deleInfo" class="btn" @click="deletePerson(scope.row)">删除</span>
            <span v-if="resetPasswordInfo" class="btn" @click="resetPassword(scope.row)">重置密码</span>
          </template>
        </el-table-column>
      </el-table>
      <page :page="page" class="page-1" @handleSizeChange="handleSizeChange" @handleCurrentChange="getPersonList">
      </page>
    </div>
    <batchImport ref="batchImport" :dialog-drag-title="dialogDragTitle" :accept="accept" :need-type="needType"
      @downTemplate="downTemplate" @suredaoru="suredaoru" @getList="getList" @getfreshen="getfreshen"></batchImport>
  </div>
</template>
<script>
import editPerson from "./components/editPerson";
import page from "@/CommonDP/components/paging";
import systemPersonService from "@/CommonDP/service/enterprisePerson-service";
import { checkPermission, disablePrompt } from "@/CommonDP/utils/routeAuth";
import { downloadFile, downloadTemplate, downloadTempEnterpriseUser } from "@/CommonDP/utils";
import { mapState } from "vuex";
import globalParams from "@/CommonDP/utils/globalParams";
import batchImport from "@/CommonDP/components/batchImport";

export default {
  name: "PersonInfo",
  components: { editPerson, page, batchImport },
  data() {
    return {
      invitationInfo: checkPermission(this.$allPerms.PERSONINFO_INVITATION),
      moreMember: checkPermission(this.$allPerms.PERSONINFO_MOREMEMBER),
      deleBatchInfo: checkPermission(this.$allPerms.PERSONINFO_DELEBATCH),
      exportInfo: checkPermission(this.$allPerms.PERSONINFO_EXPORT),
      seeInfo: checkPermission(this.$allPerms.PERSONINFO_SEE),
      editInfo: checkPermission(this.$allPerms.PERSONINFO_EDIT),
      deleInfo: checkPermission(this.$allPerms.PERSONINFO_DELE),
      addPersonInfo: checkPermission(this.$allPerms.PERSONINFO_ADDPERSON),
      resetPassInfo: checkPermission(this.$allPerms.PERSONINFO_RESETPASS),
      addInfo: checkPermission(this.$allPerms.PERSONINFO_ADD),
      enableInfo: checkPermission(this.$allPerms.PERSONINFO_ENABLE),
      resetPasswordInfo: checkPermission(this.$allPerms.PERSONINFO_PWD_RESET),
      exportBatch: checkPermission(this.$allPerms.PERSONINFO_EXPORT_BATCH),
      zanwu: require("@/CommonDP/assets/暂无数据.png"),
      enableEditEnterpriseUser: false,
      showUserName: false,
      loading: false,
      tableData: [],
      searchQuery: {
        keyword: "",
        isExternal: "",
        isEnabled: ""
      },
      page: {
        pageNum: 1,
        pageSize: 20,
        totalCount: 0
      },
      userId: undefined,
      iswaioptions: [
        { id: "1", label: "外部" },
        { id: "0", label: "内部" }
      ],
      isqiyongoptions: [
        { id: "1", label: "启用" },
        { id: "0", label: "禁用" }
      ],
      pageSelect: [], // 勾选的数据
      rows: {},
      needType: 1,
      accept: "",
      dialogDragTitle: '批量邀请'
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    })
  },
  created() {
    this.manageGlobalParams();
    this.getPersonList(1);
  },
  methods: {
    manageGlobalParams() {
      this.enableEditEnterpriseUser = !globalParams.getFn("enterprise.user.readonly");
      this.showUserName = globalParams.get("enterprise.user.showUserName");
    },
    changeinput() {
      this.getPersonList(1);
    },
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getPersonList(1);
    },
    // 人员列表接口
    getPersonList(index = 1) {
      this.$nextTick(() => {
        this.$refs.multipleTable.clearSelection();
      });
      const {
        page: { pageSize },
        searchQuery: { keyword, isExternal, isEnabled },
        enterpriseId
      } = this;
      const params = {
        keyword,
        pageSize,
        pageNum: index,
        isEnabled,
        isExternal,
        enterpriseId
      };
      systemPersonService.personListTable(params).then(({ data, totalCount, pageNum }) => {
        const list = data.map((person) => {
          const isEnableds = ["禁用", "启用"];
          const sex = ["", "男", "女"];
          return {
            depName: "",
            depNametitle: "",
            $isEnabled: isEnableds[person.isEnabled],
            $sex: sex[person.sex],
            ...person
          };
        });
        this.page.pageNum = pageNum;
        this.page.totalCount = totalCount;
        this.tableData = list;
        for (var i = 0; i < this.tableData.length; i++) {
          if (this.tableData[i].deptList.length) {
            for (var l = 0; l < this.tableData[i].deptList.length; l++) {
              this.tableData[i].depName += this.tableData[i].deptList[l].deptName + ";";
              this.tableData[i].depNametitle += this.tableData[i].deptList[l].fullDeptName + ";";
            }
            // 去掉最后一个符号
            this.tableData[i].depName = this.tableData[i].depName.substring(0, this.tableData[i].depName.length - 1);
            this.tableData[i].depNametitle = this.tableData[i].depNametitle.substring(0, this.tableData[i].depNametitle.length - 1);
          }
        }
        var data222 = [];
        for (var s = 0; s < this.pageSelect.length; s++) {
          for (var g = 0; g < this.tableData.length; g++) {
            if (this.pageSelect[s].userId === this.tableData[g].userId) {
              data222.push(this.tableData[g]);
            }
          }
        }
        this.toggleSelection(data222);
        this.userId = undefined;
        this.loading = false;
      });
    },
    // 翻页勾选
    toggleSelection(rows) {
      this.$nextTick(() => {
        if (rows) {
          rows.forEach((row) => {
            this.$refs.multipleTable.toggleRowSelection(row);
          });
        } else {
          this.$refs.multipleTable.clearSelection();
        }
      });
    },
    // 选中的节点
    handleDelete(selection) {
      console.log(selection, "点击");
      this.userId = selection.userId;
    },
    // 删除人员
    deletePerson(row) {
      const a = disablePrompt();
      if (a) {
        const params = { enterpriseId: this.enterpriseId, userIds: [] };
        params.userIds.push(row.userId);
        this.$confirm("此操作将删除本行数据，是否继续？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            systemPersonService
              .personnelmanagedelete(params)
              .then(() => {
                this.getfreshen(); // 刷新列表
                this.$message({
                  showClose: true,
                  type: "success",
                  message: "删除成功"
                });
              })
              .catch(() => {});
          })
          .catch(() => {
            this.getfreshen();
          });
        this.userId = undefined;
      }
    },
    // 批量删除人员
    pldeletePerson() {
      const a = disablePrompt();
      if (a) {
        const params = { enterpriseId: this.enterpriseId, userIds: [] };
        for (var i = 0; i < this.pageSelect.length; i++) {
          params.userIds.push(this.pageSelect[i].userId);
        }
        this.$confirm("此操作将删除数据，是否继续？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            systemPersonService.personnelmanagedelete(params).then(() => {
              this.getfreshen(); // 刷新列表
              this.$message({
                showClose: true,
                type: "success",
                message: "删除成功"
              });
              this.pageSelect = [];
            });
          })
          .catch(() => {
            this.getfreshen();
          });
      }
    },
    async resetPassword(row) {
      this.$confirm("是否确定重置密码？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          await systemPersonService.userInitPassword(row.userId);
          this.$message({ showClose: true, type: "success", message: "重置密码成功" });
        })
        .catch(() => {
          console.log();
        });
    },
    getfreshen() {
      this.getPersonList(1);
    },
    getfreshen1() {
      this.userId = undefined;
      this.getPersonList(1);
    },
    async detailInfo(row) {
      const a = disablePrompt();
      if (a) {
        const { data } = await systemPersonService.detailPerson(row.enterpriseUserId);
        if (data.sex) {
          if (data.sex === "1") {
            data.sex = "男";
          } else {
            data.sex = "女";
          }
        }
        this.$refs.add.setPersonInfo(data, 1);
      }
    },
    // 编辑
    async editPerson(row) {
      const a = disablePrompt();
      if (a) {
        const { data } = await systemPersonService.detailPerson(row.enterpriseUserId);
        if (data.sex) {
          if (data.sex === "1") {
            data.sex = "男";
          } else {
            data.sex = "女";
          }
        }
        this.$refs.add.setPersonInfo(data, 2);
      }
    },
    yaoqing(val) {
      const a = disablePrompt();
      if (a) {
        if (val === 1) {
          this.$router.push({
            path: "/addpersonInfo",
            query: { showType: "invite" }
          });
        } else {
          this.$router.push({
            path: "/addpersonInfo",
            query: { showType: "add" }
          });
        }
      }
    },
    qiyong(row) {
      const a = disablePrompt();
      if (a) {
        this.$confirm("确定启用，是否继续？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            systemPersonService.enabled(row.enterpriseUserId, true).then(() => {
              this.getfreshen(); // 刷新列表
              this.$message({
                showClose: true,
                type: "success",
                message: "启用成功"
              });
            });
          })
          .catch(() => {
            this.getfreshen();
          });
      }
    },
    jinyong(row) {
      const a = disablePrompt();
      if (a) {
        this.$confirm("确定禁用，是否继续？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            systemPersonService.enabled(row.enterpriseUserId, false).then(() => {
              this.getfreshen(); // 刷新列表
              this.$message({
                showClose: true,
                type: "success",
                message: "禁用成功"
              });
            });
          })
          .catch(() => {
            this.getfreshen();
          });
      }
    },
    selectall(rows) {
      if (rows.length) {
        var result = [];
        if (this.pageSelect.length) {
          for (var i = 0; i < this.tableData.length; i++) {
            var obj = this.tableData[i];
            var num = obj.userId;
            var isExist = false;
            for (var j = 0; j < this.pageSelect.length; j++) {
              var aj = this.pageSelect[j];
              var n = aj.userId;
              if (n === num) {
                isExist = true;
                break;
              }
            }
            if (!isExist) {
              result.push(obj);
            }
          }
          for (var u = 0; u < result.length; u++) {
            this.pageSelect.push(result[u]);
          }
        } else {
          for (var q = 0; q < this.tableData.length; q++) {
            this.pageSelect.push(this.tableData[q]);
          }
        }
      } else {
        for (var t = 0; t < this.tableData.length; t++) {
          this.removeByValue(this.pageSelect, "userId", this.tableData[t].userId);
        }
      }
    },
    selectchange(rows, row) {
      const selected = rows.length && rows.indexOf(row) !== -1;
      if (!selected) {
        this.removeByValue(this.pageSelect, "userId", row.userId);
      } else {
        this.pageSelect.push(row);
      }
    },
    // 复选框不勾选时需要调用的函数
    removeByValue(arr, attr, value) {
      // 数组，属性，属性值
      var index = 0;
      for (var i in arr) {
        if (arr[i][attr] === value) {
          index = i;
          break;
        }
      }
      arr.splice(index, 1);
    },
    daoru(type) {
      const a = disablePrompt();
      if (a) {
        this.needType = type === 1 ? 1 : 2;
        this.dialogDragTitle = type === 1 ? '批量邀请' : '批量导入';
        this.accept = type === 1 ? '.xlsx,.xls' : '.xlsx';
        this.$refs.batchImport.batchImportDialogVisible = true;
      }
    },
    suredaoru(fileLis) {
      this.$refs.batchImport.disabledone = true;
      const data = new FormData();
      data.append("file", fileLis);
      data.append("enterpriseId", this.enterpriseId);
      if (this.needType === 1) {
        systemPersonService.enterpriseimport(data)
          .then((res1) => {
            this.$refs.batchImport.commonSuredaoru(res1);
          })
          .catch(() => {
            this.$refs.batchImport.disabledone = false;
          });
      } else {
        systemPersonService.enterpriseUserImport(data)
          .then((res1) => {
            this.$refs.batchImport.commonSuredaoru(res1);
          })
          .catch(() => {
            this.$refs.batchImport.disabledone = false;
          });
      }
    },
    async getList(failList) {
      if (this.needType === 1) {
        systemPersonService.drawingDrawingQuesExport(failList)
          .then((response) => {
            this.$refs.batchImport.commonGetList(response);
          });
      } else {
        systemPersonService.inviteEnterpriseUserExport(failList)
          .then((response) => {
            this.$refs.batchImport.commonGetList(response);
          });
      }
    },
    downTemplate() {
      const downzipurl = this.needType === 1 ? downloadTemplate() : downloadTempEnterpriseUser();
      downloadFile(downzipurl);
    },
    gomorepersonInfo() {
      const a = disablePrompt();
      if (a) {
        this.$router.push("/morepersonInfo");
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.all {
  height: 100%;
  background: #fff;
  position: relative;
  min-width: 980px;
  display: flex;
  flex-direction: column;
  .header_top {
    .icon_1 {
      color: #1089c8;
      font-size: 23px;
    }
    .topTitle {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      border-bottom: 1px solid #e5e8f1;
      padding: var(--middle-space) var(--big-space);
      .title {
        color: var(--key-color);
        font-size: 16px;
        font-weight: 700;
      }
    }
    /deep/.el-input__suffix{
      top: -2px;
    }
  }

  .content {
    height: 1px;
    flex: 1 0 1px;
    padding: 0 var(--big-space);
    display: flex;
    flex-direction: column;
    .page-1 {
      padding: var(--middle-space) 0;
      text-align: right;
    }
  }
  h4 {
    line-height: 20px;
    font-size: 14px;
    color: #fff;
    padding-left: 10px;
    margin-top: 5px;
    background-color: rgb(170, 165, 165);
  }
  .btn {
    cursor: pointer;
    color: var(--theme-color);
    margin-right: 6px;
  }
  /deep/ .profession-dialog {
    border-radius: 5px;
    .el-dialog__body {
      padding: 20px;
      border-top: 1px solid #2e5bff1a;
      border-bottom: 1px solid #2e5bff1a;
      .el-radio {
        height: 25px;
      }
      .el-form-item {
        margin-bottom: 10px;
      }
    }
    .el-table__empty-text {
      line-height: 30px;
    }
    .el-textarea__inner {
      height: 200px;
    }
  }
}
</style>
